import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

const ADMIN_PASSWORD = 'P2Pnokyc';

interface AdminAuthProps {
  children: React.ReactNode;
}

const AdminAuth = ({ children }: AdminAuthProps): JSX.Element => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="bg-[#333333] p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex justify-center mb-8">
          <img src="/images/secondary-logo-white.svg" alt="Vexl Logo" className="h-16" />
        </div>
        <h2 className="text-2xl font-bold mb-6 text-brand-yellow text-center">Admin Access</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="password"
              placeholder="Enter Admin Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#28332a] text-white p-3 rounded-lg border border-brand-yellow/30 focus:border-brand-yellow focus:outline-none"
            />
            {error && <p className="text-red-400 mt-2">{error}</p>}
          </div>
          <button
            type="submit"
            className="w-full bg-brand-yellow text-black font-bold py-3 rounded-lg hover:bg-[#fccd6c]/90 transition-colors"
          >
            Access Admin Panel
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminAuth; 